var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.job === null)?_c('not-found'):_c('router-view',{attrs:{"department":_vm.department,"deptinfo":_vm.dept_info,"locations":_vm.locations}})
}
var staticRenderFns = []

export { render, staticRenderFns }